import React from 'react';
import PropTypes from 'prop-types';
import AddressSearchTypeaheadContainer from '../../redux/containers/AddressSearchTypeaheadContainer';
import AddressSearchLoadingContainer from '../../redux/containers/AddressSearchLoadingContainer';
import AddressSearchMessagesContainer from '../../redux/containers/AddressSearchMessagesContainer';
import SectionHeading from '../SectionHeading/SectionHeading';
import './AddressSearch.scss';

const AddressSearch = (props) => {
  const { headingNumber, subTitle, description, isChange } = props;
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <SectionHeading
            number={headingNumber}
            title={subTitle}
            titleClassName={'address-search-section-title'}
            numberClassName={'address-search-heading-number'}
            description={description}
          />
          <div className="input-group">
            <AddressSearchTypeaheadContainer isChange={isChange} />
            <AddressSearchLoadingContainer />
          </div>
          <AddressSearchMessagesContainer />
        </div>
      </div>
    </div>
  );
};

AddressSearch.propTypes = {
  headingNumber: PropTypes.number,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  isChange: PropTypes.bool
};

export default AddressSearch;



/** WEBPACK FOOTER **
 ** ./src/components/AddressSearch/AddressSearch.js
 **/